export default __webpack_public_path__ + "static/media/virtual-tour-slide-1-tablet.a2bea0bd.png";